import { useState } from 'react'
import { Card, CardBody, Heading, HStack, Switch, TabPanel, VStack } from '@chakra-ui/react'

import { useAddPlayerContext } from '@contexts/AddPlayerContext'

import { AllPlayersSearchField, CaptainSwitch, GetPlayerByIdField, ShirtNumberField } from './FormFields'
import { PlayerCardHeader } from './PlayerCardHeader'

export function ExistingPlayerTabPanel() {
    const [isGetById, setIsGetById] = useState(false)
    const { newPlayer, isSubstitute } = useAddPlayerContext()

    return (
        <TabPanel px={0}>
            <HStack display="flex" alignItems="initial">
                <Heading size="sm" mb={2} fontStyle="italic">
                    GET BY ID
                </Heading>
                <Switch
                    tabIndex={-1}
                    id="get-by-id"
                    isChecked={isGetById}
                    onChange={e => setIsGetById(e.target.checked)}
                />
            </HStack>
            {!isGetById && <AllPlayersSearchField />}
            {isGetById && <GetPlayerByIdField />}

            {newPlayer.surname && (
                <Card size="md" mt={4}>
                    <PlayerCardHeader />
                    <CardBody pt={0}>
                        <VStack spacing={4}>
                            <ShirtNumberField />

                            {!isSubstitute && <CaptainSwitch />}
                        </VStack>
                    </CardBody>
                </Card>
            )}
        </TabPanel>
    )
}
